export type BookingPostRef = {
  post?: { uuid?: string } | null;
  post_uuid?: unknown;
};

const readUuid = (value: unknown): string | undefined => {
  if (typeof value === 'string' && value) {
    return value;
  }

  if (value && typeof value === 'object' && 'uuid' in value) {
    const uuid = (value as { uuid?: unknown }).uuid;
    if (typeof uuid === 'string' && uuid) {
      return uuid;
    }
  }

  return undefined;
};

/**
 * UUID поста: сначала post_uuid (свежий getOne), затем вложенный post из списка.
 */
export const getBookingPostUuid = (booking: BookingPostRef): string | undefined => {
  return readUuid(booking.post_uuid) ?? readUuid(booking.post);
};
